import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './pages/main/main.component';
import { BlankComponent } from './views/blank/blank.component';
import { LoginComponent } from './pages/login/login.component';
import { ProfileComponent } from './views/profile/profile.component';
import { RegisterComponent } from './pages/register/register.component';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { AuthGuard } from './utils/guards/auth.guard';
import { NonAuthGuard } from './utils/guards/non-auth.guard';
import { ConfigurationComponent } from './views/configuration/configuration.component';
import { StatusComponent } from './views/status/status.component';
import { ConfigurationFixerComponent } from './views/configuration-fixer/configuration-fixer.component';
import { LoggerComponent } from './views/logger/logger.component';
import { OnboardingEditComponent } from './views/onboarding-edit/onboarding-edit.component';
import { OnboardingsComponent } from './views/onboardings/onboardings.component';
import { GithubComponent } from './views/github/github.component';
import { MenusComponent } from './views/menus/menus.component';
import { OrganisationsComponent } from './views/organisations/organisations.component';
import { CardsComponent } from './views/cards/cards.component';
import { ConnectorsComponent } from './views/connectors/connectors.component';
import { RssValidatorComponent } from './views/rss-validator/rss-validator.component';
import { RssFeedsComponent } from './views/rss-feeds/rss-feeds.component';
import { MessagesComponent } from './views/messages/messages.component';
import { CalendarsComponent } from './views/calendars/calendars.component';
import { UserImportComponent } from './views/user-import/user-import.component';
import { FeaturesComponent } from './views/features/features.component';
import { DiscrepanciesComponent } from './views/discrepancies/discrepancies.component';
import { OrganisationUpdateComponent } from './views/organisation-update/organisation-update.component';
import { NoticesComponent } from './views/notices/notices.component';
import { VendorListComponent } from './views/vendor-list/vendor-list.component';
import { CollectsAiAnalytics } from './views/analytics/collects-ai/analytics.component';

const routes: Routes = [
    {
        path: '',
        component: MainComponent,
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        children: [
            {
                path: 'notices',
                component: NoticesComponent,
            },
            {
                path: 'messages',
                component: MessagesComponent,
            },
            {
                path: 'rss-validator',
                component: RssValidatorComponent,
            },
            {
                path: 'organisation/:tag/rss-feeds',
                component: RssFeedsComponent,
            },
            {
                path: 'profile',
                component: ProfileComponent,
            },
            {
                path: 'blank',
                component: BlankComponent,
            },
            {
                path: 'configuration-fixer',
                component: ConfigurationFixerComponent,
            },
            {
                path: 'configuration',
                component: ConfigurationComponent,
            },
            {
                path: 'status',
                component: StatusComponent,
            },
            {
                path: 'menus',
                component: MenusComponent,
            },
            {
                path: 'organisations',
                component: OrganisationsComponent,
            },
            {
                path: 'organisation/:tag',
                component: OrganisationUpdateComponent,
            },
            {
                path: 'organisation/:tag/cards',
                component: CardsComponent,
            },
            {
                path: 'organisation/:tag/connectors',
                component: ConnectorsComponent,
            },
            {
                path: 'organisation/:tag/calendar',
                component: CalendarsComponent,
            },
            {
                path: 'organisation/:tag/features',
                component: FeaturesComponent,
            },
            {
                path: 'organisation/:tag/user-import',
                component: UserImportComponent,
            },
            {
                path: 'organisation/:tag/discrepancies',
                component: DiscrepanciesComponent,
            },
            {
                path: 'collects-ai-analytics',
                component: CollectsAiAnalytics,
            },
            {
                path: 'onboarding',
                component: OnboardingsComponent,
            },
            {
                path: 'onboarding/:id',
                component: OnboardingEditComponent,
            },
            {
                path: 'logger',
                component: LoggerComponent,
            },
            {
                path: 'github',
                component: GithubComponent,
            },
            {
                path: 'cards',
                component: CardsComponent,
            },
            {
                path: 'vendors',
                component: VendorListComponent,
            },
            {
                path: '',
                component: DashboardComponent,
            },
        ],
    },
    {
        path: 'login',
        component: LoginComponent,
        canActivate: [NonAuthGuard],
    },
    {
        path: 'register',
        component: RegisterComponent,
        canActivate: [AuthGuard],
    },
    { path: '**', redirectTo: '' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
    exports: [RouterModule],
})
export class AppRoutingModule {}
